/** Period utilities for MMYY format. */

const MONTH_NAMES: Record<string, string> = {
  '01': 'Январь', '02': 'Февраль', '03': 'Март', '04': 'Апрель',
  '05': 'Май', '06': 'Июнь', '07': 'Июль', '08': 'Август',
  '09': 'Сентябрь', '10': 'Октябрь', '11': 'Ноябрь', '12': 'Декабрь',
}

/** MMYY -> numeric YYMM for chronological sorting. */
export function periodToSortKey(period: string): number {
  return parseInt(period.slice(2, 4) + period.slice(0, 2), 10)
}

/** Format MMYY to human label: "Январь 2026" */
export function formatPeriod(period: string): string {
  const mm = period.slice(0, 2)
  const yy = period.slice(2, 4)
  return `${MONTH_NAMES[mm] || mm} 20${yy}`
}

/** Expand MMYY range [from, to] into list of all months. */
export function expandPeriodRange(from: string, to: string): string[] {
  const result: string[] = []
  let mm = parseInt(from.slice(0, 2), 10)
  let yy = parseInt(from.slice(2, 4), 10)
  const toKey = periodToSortKey(to)

  for (let i = 0; i < 100; i++) {  // safety limit
    const period = String(mm).padStart(2, '0') + String(yy).padStart(2, '0')
    result.push(period)
    if (periodToSortKey(period) >= toKey) break
    mm++
    if (mm > 12) { mm = 1; yy++ }
  }
  return result
}

/** Validate MMYY format. */
export function isValidPeriod(value: string): boolean {
  if (value.length !== 4 || !/^\d{4}$/.test(value)) return false
  const mm = parseInt(value.slice(0, 2), 10)
  return mm >= 1 && mm <= 12
}
